import React from "react";
import LazyLoad from "react-lazyload";
import Cookie from "../../features/Cookie";
import About from "../../sections/About";
import Allocation from "../../sections/Allocation";
import GameFeatures from "../../sections/GameFetures";
import SupportGamePlay from "../../sections/SupportGamePlay";
import Team from "../../sections/Team";
import TokenRelease from "../../sections/TokenRelease";

const Home = () => {
    return (
        <>
            <LazyLoad height={100}>
                <About />
            </LazyLoad>

            <LazyLoad height={100}>
                <SupportGamePlay />
            </LazyLoad>

            <LazyLoad height={100}>
                <GameFeatures />
            </LazyLoad>
            <LazyLoad height={100}>
                <Allocation />
            </LazyLoad>
            <LazyLoad height={100}>
                <TokenRelease />
            </LazyLoad>
            <LazyLoad height={100}>
                <Team />
            </LazyLoad>
            <Cookie />
        </>
    );
};

export default Home;
